// === ScoreView Landing Page Scripts ===

function initLandingPage() {
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    });
  }

  var mobileMenuBtn = document.getElementById('mobile-menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });

    var mobileLinks = mobileMenu.querySelectorAll('a');
    for (var i = 0; i < mobileLinks.length; i++) {
      mobileLinks[i].addEventListener('click', function () {
        mobileMenu.classList.remove('open');
      });
    }
  }

  var anchors = document.querySelectorAll('a[href^="#"]');
  for (var j = 0; j < anchors.length; j++) {
    anchors[j].addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      e.preventDefault();
      var target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  var ctaForm = document.getElementById('cta-form');
  if (ctaForm) {
    ctaForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = ctaForm.querySelector('input');
      var btn = ctaForm.querySelector('button');
      var originalText = btn.textContent;
      btn.textContent = 'Thank you!';
      setTimeout(function () {
        btn.textContent = originalText;
        input.value = '';
      }, 3000);
    });
  }

  document.documentElement.classList.add('landing-js-ready');

  var hero = document.querySelector('.hero');
  if (hero) {
    hero.classList.add('visible');
  }

  var sections = document.querySelectorAll('.animate-on-scroll');
  if (typeof IntersectionObserver === 'undefined') {
    for (var n = 0; n < sections.length; n++) {
      sections[n].classList.add('visible');
    }
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      if (entries[k].isIntersecting) {
        entries[k].target.classList.add('visible');
      }
    }
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px',
  });

  for (var m = 0; m < sections.length; m++) {
    observer.observe(sections[m]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLandingPage);
} else {
  initLandingPage();
}
